import { createFileRoute } from "@tanstack/react-router";

import { WalletDashboardRoute } from "./wallet";

export const Route = createFileRoute("/early-access")({
  head: () => ({ meta: [{ title: "Early access · GENRL" }] }),
  validateSearch: (raw: Record<string, unknown>) => ({
    stripe_status: typeof raw.stripe_status === "string" ? raw.stripe_status : undefined,
    checkout_id: typeof raw.checkout_id === "string" ? raw.checkout_id : undefined,
    session_id: typeof raw.session_id === "string" ? raw.session_id : undefined,
  }),
  component: EarlyAccessRoute,
});

function EarlyAccessRoute() {
  return <WalletDashboardRoute search={Route.useSearch()} />;
}
